import React, { Component } from 'react';
import BbRadio from './bbRadio';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import "./bbRadioWrapper.scss";

class BbRadioWrapper extends Component {
    render() {
        return (
            <label htmlFor={this.props.id} className={classnames('bb-radio-wrapper', { 'disabled': this.props.disabled})}>
                <input onChange={(e) => this.props.callback && this.props.callback(e)}
                    checked={this.props.checked} ref={el => this.radio = el}
                    type="radio" id={this.props.id}
                    name={this.props.name}
                    value={this.props.value}
                    style={{ width: 0, height: 0 }} 
                    disabled={this.props.disabled} />
                <BbRadio />
                {this.props.label && <label htmlFor={this.props.id}>{this.props.label}</label>}
                {this.props.children}
            </label>
        )
    }
}

BbRadioWrapper.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checked: PropTypes.bool.isRequired,
    label: PropTypes.string
};

export default BbRadioWrapper;
